import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_ItemLink = _resolveComponent("ItemLink")!
  const _component_item = _resolveComponent("item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!_ctx.item.meta || !_ctx.item.meta.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.isCollapse ? 'simple-mode' : 'full-mode'])
      }, [
        (!_ctx.alwaysShowRootMenu && _ctx.theOnlyOneChild && !_ctx.theOnlyOneChild.children)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.theOnlyOneChild.meta)
                ? (_openBlock(), _createBlock(_component_ItemLink, {
                    key: 0,
                    to: _ctx.resolvePath(_ctx.theOnlyOneChild.path)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: _ctx.resolvePath(_ctx.theOnlyOneChild.path)
                      }, {
                        default: _withCtx(() => [
                          (_ctx.theOnlyOneChild.meta.icon)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(["icon iconfont", _ctx.theOnlyOneChild.meta.icon])
                              }, null, 2))
                            : _createCommentVNode("", true),
                          (_ctx.theOnlyOneChild.meta.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.theOnlyOneChild.meta.title), 1))
                            : _createCommentVNode("", true),
                          (_ctx.theOnlyOneChild.meta.badge && _ctx.menuWarning[_ctx.theOnlyOneChild.meta.badge] > 0)
                            ? (_openBlock(), _createBlock(_component_el_badge, {
                                key: 2,
                                "is-dot": _ctx.theOnlyOneChild.meta.badge && _ctx.menuWarning[_ctx.theOnlyOneChild.meta.badge] > 0 && _ctx.theOnlyOneChild.meta.withoutNum,
                                value: _ctx.menuWarning[_ctx.theOnlyOneChild.meta.badge],
                                max: 99,
                                type: "warning"
                              }, null, 8, ["is-dot", "value"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["index"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path),
              teleported: ""
            }, {
              title: _withCtx(() => [
                (_ctx.item.meta && _ctx.item.meta.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["icon iconfont", _ctx.item.meta.icon])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (_ctx.item.meta && _ctx.item.meta.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.item.meta.title), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_ctx.item.children)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_item, {
                        key: child.path,
                        item: child,
                        "is-collapse": _ctx.isCollapse,
                        "is-first-level": false,
                        "base-path": _ctx.resolvePath(child.path),
                        class: "nest-menu"
                      }, null, 8, ["item", "is-collapse", "base-path"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index"]))
      ], 2))
    : _createCommentVNode("", true)
}